module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/modal-window/message-popup/message-popup.component.sass
// module id = ./src/app/modules/modal-window/message-popup/message-popup.component.sass
// module chunks = main